import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.search;

export const searchAllLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});
export const searchAllErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});
export const searchAllDataSelector = createSelector([baseState], (state) => {
    return {
        count: state.data.length,
        video: state.data.filter(i => i.type === "video"),
        directory: state.data.filter(i => i.type === "directory"),
        event: state.data.filter(i => i.type === "event"),
        threads: state.data.filter(i => i.type === "thread"),
        companies: state.data.filter(i => i.type === "companies"),
        users: state.data.filter(i => i.type === "users")
    };
});